import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image
} from "@react-pdf/renderer";
import fontBold from "./fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "./fonts/NotoSansTamil-Regular.ttf";

// Register Tamil fonts
Font.register({
  family: "fontBold",
  src: fontBold,
});
Font.register({
  family: "fontRegular",
  src: fontRegular,
});

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}.${month}.${year}`;
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: "#fff",
    fontFamily: "fontRegular",
  },
  container: {
    borderWidth: 1.5,
    borderColor: "#000",
    padding: 15,
    flexDirection: "column",
    position: "relative",
    minHeight: 740,
  },
  sideTextContainer: {
    position: "absolute",
    left: -140,
    top: 300,
    width: 350,
    transform: "rotate(-90deg)",
  },
  sideText: {
    fontSize: 8.5,
    fontFamily: "fontBold",
    lineHeight: 1.4,
    textAlign: "center",
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 5,
  },
  formName: {
    fontSize: 9,
  },
  rsBox: {
    borderWidth: 1.5,
    borderColor: "#000",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 3,
    minWidth: 110,
  },
  rsLabel: {
    fontSize: 11,
    fontFamily: "fontBold",
  },
  rsValue: {
    fontSize: 16,
    fontFamily: "fontBold",
    marginLeft: 10,
  },
  invocations: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 3,
  },
  storeName: {
    fontSize: 26,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 10,
  },
  subHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 10,
  },
  pawnNoContainer: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 12,
  },
  pawnNoBox: {
    borderWidth: 1,
    borderColor: "#000",
    paddingHorizontal: 8,
    marginHorizontal: 4,
    minWidth: 30,
    textAlign: "center",
    height: 20,
    justifyContent: "center",
  },
  pawnTicketBox: {
    backgroundColor: "#000",
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: 3,
  },
  pawnTicketText: {
    color: "#fff",
    fontSize: 14,
    fontFamily: "fontBold",
  },
  ownerInfo: {
    fontSize: 10,
    textAlign: "right",
    width: "45%",
    lineHeight: 1.4,
  },
  licenseRow: {
    fontSize: 11,
    marginBottom: 5,
  },
  statement: {
    fontSize: 12,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 15,
    textDecoration: "underline",
  },
  table: {
    borderWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 40,
  },
  rowSno: {
    width: "8%",
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 8,
    fontSize: 11,
    textAlign: "center",
    justifyContent: "center",
  },
  rowLabel: {
    width: "44%",
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 8,
    fontSize: 11,
    justifyContent: "center",
  },
  rowValue: {
    width: "48%",
    padding: 8,
    fontSize: 12,
    fontFamily: "fontBold",
    justifyContent: "center",
  },
  phoneRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  phoneLabel: {
    marginTop: 8,
    fontSize: 10,
    marginRight: 10,
  },
  rowHeight5: {
    minHeight: 60,
  },
  weightContainer: {
    flexDirection: "column",
    marginTop: 5,
  },
  weightLine: {
    flexDirection: "row",
    alignItems: "baseline",
    fontSize: 11,
  },
  dots: {
    borderBottomWidth: 1,
    borderStyle: "dotted",
    flex: 1,
    marginHorizontal: 5,
  },
  footer: {
    marginTop: 10,
  },
  // Page 2 Styles
  page2Container: {
    padding: 10,
    alignItems: "center",
  },
  topText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 15,
    marginTop: 10,
  },
  businessHoursBox: {
    borderWidth: 1.2,
    borderColor: "#000",
    borderRadius: 8,
    padding: 10,
    width: "85%",
    marginBottom: 20,
    alignItems: "center",
  },
  businessHoursTitle: {
    fontSize: 13,
    fontFamily: "fontBold",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: 8,
  },
  businessHoursText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    lineHeight: 1.4,
  },
  conditionsHeader: {
    backgroundColor: "#333",
    borderRadius: 12,
    paddingHorizontal: 25,
    paddingVertical: 4,
    marginBottom: 15,
  },
  conditionsHeaderText: {
    color: "#fff",
    fontSize: 13,
    fontFamily: "fontBold",
  },
  conditionsList: {
    width: "100%",
    paddingHorizontal: 5,
  },
  conditionRow: {
    flexDirection: "row",
    marginBottom: 7,
    lineHeight: 1.4,
  },
  conditionNumber: {
    fontSize: 10,
    fontFamily: "fontBold",
    width: 20,
  },
  conditionText: {
    fontSize: 10,
    fontFamily: "fontBold",
    flex: 1,
    textAlign: "justify",
  },
  bottomText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginTop: 20,
  },
  footerText: {
    fontSize: 11,
    fontFamily: "fontBold",
    textAlign: "center",
    marginBottom: 5,
  },
  signatureRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 40,
    width: "100%",
    paddingHorizontal: 10,
  },
  signatureText: {
    fontSize: 11,
    fontFamily: "fontBold",
  },
  // Image styles
  imageContainer: {
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    width: "100%",
    marginTop: 10,
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 5,
  },
  imageWrapper: {
    width: "45%",
    height: 120,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  proofImage: {
    width: 120,
    height: 120,
    objectFit: "contain",
  },
  emptyImagePlaceholder: {
    width: 120,
    height: 120,
    borderWidth: 1,
    borderColor: "#ccc",
    backgroundColor: "#f9f9f9",
  },
});

const JewelPawnPdf = ({ data }) => {
  if (!data) return null;

  // Split receipt number if possible (e.g., E 9101)
  const receiptNo = data.receipt_no || "";
  const prefix = receiptNo.charAt(0);
  const number = receiptNo.substring(1);

  const weightStr = data.jewel_weight ? data.jewel_weight.toString() : "";
  const weightParts = weightStr.split(".");
  const grams = weightParts[0] || "";
  const milligrams = weightParts[1] || "";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          {/* Vertical Side Text */}


          {/* Header Section with Images */}
          <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            {/* Left: Jewel Image 1 */}
            <View style={{ width: 80, height: 80, borderWidth: 1, borderColor: "#000", justifyContent: "center", alignItems: "center" }}>
              {data.proof && data.proof.length > 0 && data.proof[0] ? (
                <Image src={data.proof[0]} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              ) : (
                <Text style={{ fontSize: 9 }}>customer</Text>
              )}
            </View>

            {/* Center: Invocations & Store Name */}
            <View style={{ flex: 1, alignItems: "center", paddingHorizontal: 10 }}>
              <Text style={styles.invocations}>
                {data.shop_invocation1 || "ஸ்ரீ கப்பலூர் காளி துணை"}
              </Text>
              <Text style={styles.invocations}>
                {data.shop_invocation2 || "ஆதிகாமாட்சியம்மன் துணை"}
              </Text>
              <Text style={[styles.storeName, { marginTop: 5, marginBottom: 0 }]}>
                {data.shop_name || "ஸ்ரீ விக்னேஷ்வரா பைனான்ஸ்"}
              </Text>
            </View>

            {/* Right: Jewel Image 2 */}
            <View style={{ width: 80, height: 80, borderWidth: 1, borderColor: "#000", justifyContent: "center", alignItems: "center" }}>
              {data.proof && data.proof.length > 1 && data.proof[1] ? (
                <Image src={data.proof[1]} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              ) : (
                <Text style={{ fontSize: 9 }}>Jewel</Text>
              )}
            </View>
          </View>

          <View style={styles.subHeader}>
            <View style={styles.pawnNoContainer}>
              <Text>அடகு No.</Text>
              <View style={[styles.pawnNoBox, { minWidth: 60 }]}>
                <Text>{receiptNo}</Text>
              </View>
            </View>
            <View style={styles.pawnTicketBox}>
              <Text style={styles.pawnTicketText}>அடகு சீட்டு</Text>
            </View>
            {/* <View style={styles.ownerInfo}>
              <Text style={{ fontFamily: "fontBold" }}>{data.shop_owner_name || ""}</Text>
              <Text>{data.shop_address || ""}</Text>
              <Text>{data.shop_place || ""}</Text>
            </View> */}
          </View>
          <Text style={styles.licenseRow}>அடகு வைத்{""}துக் கொண்டு கடன் கொடுப்பவரின் பெயர்:  {data.shop_license_no || "V.விஜயா"}</Text>
          <Text style={styles.licenseRow}>மற்றும் விலாசம் : {data.shop_license_no || "1/52/1, விநாயகர் கோவில் தெரு, கப்பலூர், திருமங்கலம் TK."}</Text>
          <Text style={styles.licenseRow}>லைசென்{""}ஸ் நம்பரும், தேதியும் : {data.shop_license_no || "4/96-97"}</Text>
          <Text style={styles.statement}>அடியிற்கண்{""}ட சொத்{""}துக்{""}கள் என்னிடம் அடகு வைக்கப்பட்{""}டுள்ளன.</Text>

          {/* Main Table */}
          <View style={styles.table}>
            {/* Row 1: Name & Address */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>1.</Text>
              </View>
              <View style={[styles.rowLabel, { justifyContent: "space-between" }]}>
                <View>
                  <Text>அடகு வைப்{""}பவர் பெயரு{""}ம் பூரண விலாசமு{""}ம்</Text>
                </View>
                <View style={{ alignItems: "flex-end", marginTop: 10 }}>
                  <Text style={{ fontSize: 11, marginRight: 5 }}>போ{""}ன் ந{""}ம்{""}ப{""}ர் </Text>
                </View>
              </View>
              <View style={[styles.rowValue, { justifyContent: "space-between" }]}>
                <View>
                  <Text>{data.name || ""}</Text>
                  <Text style={{ fontSize: 10, marginTop: 5, fontFamily: "fontRegular" }}>
                    {data.place || ""}
                  </Text>
                </View>
                <View style={{ marginTop: 10 }}>
                  <Text style={{ fontSize: 12, fontFamily: "fontBold" }}>
                    {data.mobile_number || ""}
                  </Text>
                </View>
              </View>
            </View>

            {/* Row 2: Date */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>2.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>தேதி</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{formatDate(data.pawnjewelry_date)}</Text>
              </View>
            </View>

            {/* Row 3: Principal Amount */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>3.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>கட{""}ன் தொகையி{""}ன் அசல்.</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>ரூபாய் {data.original_amount || ""}</Text>
              </View>
            </View>

            {/* Row 4: Interest Rate */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>4.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>வட்{""}டி விகித{""}ம் %</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{data.interest_rate || ""}</Text>
              </View>
            </View>

            {/* Row 5: Item Description & Weight */}
            <View style={[styles.tableRow, styles.rowHeight5]}>
              <View style={styles.rowSno}>
                <Text>5.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>பொருள்களி{""}ன் பூரண விபர{""}ம்.</Text>
                <Text style={{ marginTop: 5 }}>நகைகளாக இருந்{""}தால் எடை</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{data.pledged_items || ""}</Text>
                <View style={styles.weightContainer}>
                  <View style={styles.weightLine}>
                    <Text>கிராம்</Text>
                    <View style={{ flex: 1, borderBottomWidth: 1, borderStyle: "dotted", marginHorizontal: 5, alignItems: "center", justifyContent: "flex-end" }}>
                      <Text style={{ fontSize: 14, fontFamily: "fontBold", marginBottom: 2 }}>{grams}</Text>
                    </View>
                    <Text>மி.கிராம்</Text>
                    <View style={{ flex: 1, borderBottomWidth: 1, borderStyle: "dotted", marginHorizontal: 5, alignItems: "center", justifyContent: "flex-end" }}>
                      <Text style={{ fontSize: 14, fontFamily: "fontBold", marginBottom: 2 }}>{milligrams}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>

            {/* Row 6: Item Value */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>6.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>பொருள்களி{""}ன் மதிப்{""}பு.</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>ரூபாய் </Text>
              </View>
            </View>

            {/* Row 7: Period */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>7.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>அடகை மீட்{""}க ஒப்{""}புக்கொள்ளப்ப{""}டும் கால{""}ம்.</Text>
              </View>
              <View style={styles.rowValue}>
                <Text>{data.Jewelry_recovery_agreed_period || ""}</Text>
              </View>
            </View>

            {/* Row 8: Pledger Signature */}
            <View style={styles.tableRow}>
              <View style={styles.rowSno}>
                <Text>8.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>அடகு வைத்{""}தவரி{""}ன் கையெழுத்{""}து அல்{""}ல{""}து கைக்{""}குறி</Text>
              </View>
              <View style={styles.rowValue} />
            </View>

            {/* Row 9: Lender Signature */}
            <View style={[styles.tableRow, { borderBottomWidth: 0 }]}>
              <View style={styles.rowSno}>
                <Text>9.</Text>
              </View>
              <View style={styles.rowLabel}>
                <Text>அடகு வைத்{""}துக்{""}கொண்டு கடன் கொடுப்{""}பவரின் அல்{""}ல{""}து அவருடைய ஏஜெண்{""}டு கையெழுத்{""}து</Text>
              </View>
              <View style={styles.rowValue} />
            </View>
          </View>
        </View>
      </Page>

      {/* Page 2: Terms and Conditions */}
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          <View style={styles.page2Container}>
            <Text style={styles.topText}>
              கண்{""}டிப்பாக இந்{""}த ரசீதை அடகு வைத்{""}தவர் கொண்டு வந்{""}தால் தான் நகை கொடுக்கப்ப{""}டும்.
            </Text>

            <View style={styles.businessHoursBox}>
              <Text style={styles.businessHoursTitle}>வியாபார நேரம் :</Text>
              <Text style={styles.businessHoursText}>
                காலை 9.00 மணி முதல் இரவு 8.00 மணிவரை{"\n"}
                ஞாயிறு பகல் 1.00 மணி வரை{"\n"}
                முக்கிய பண்டிகை நாட்களில் கடை விடுமுறை
              </Text>
            </View>

            <View style={styles.conditionsHeader}>
              <Text style={styles.conditionsHeaderText}>நிபந்தனைகள்</Text>
            </View>

            <View style={styles.conditionsList}>
              {[
                { n: "1.", t: "வட்|டி அசல் முழுத்|தொகை செலுத்|தியபின் நகை மறுநா|ள் (அல்|ல|து) அரசாங்க குறிப்|பு எ|ண் 143848/சி.பி.ஐ. /665 தேதி 29.3.67 படி 7வது நா|ள் தான் அடகு பொருள் தரப்ப|டும்." },
                { n: "2.", t: "மாதத்|தின் ஒரு பகுதியை மாதமாக கணக்|கிடப்ப|டும்." },
                { n: "3.", t: "இந்|த ரசீது தொலைந்|து விட்|டாலோ (அ) வீடு மாறி|னாலோ எங்|களுக்கு தெரிவிக்|க வேண்|டும்." },
                { n: "4.", t: "3 மாதத்|திற்கு ஒருமுறை வட்|டி செலுத்|த வேண்|டும்." },
                { n: "5.", t: "ஏற்கனவே அடகு வைத்|தபின், அந்|த நகையையும் மீட்|டுக் கொண்டு இந்|த பொருளை பெற்|றுக் கொள்|கிறேன்." },
                { n: "6.", t: "இந்|த ரசீதை வெளியா|ர் மூலம் கொடுத்|தனுப்|பி நகை பெற்|றுக் கொண்|டாலும் அதற்|கு கடைக்கா|ரர் ஜவாப்|தாரியல்|ல." },
                { n: "7.", t: "அடகு வைத்|த பொருளை அடகு வைத்|தவர்கள் மட்|டுமே வாங்|கிச் செல்|லவேண்|டும்." },
                { n: "8.", t: "நகையை திரும்|ப வரும் பொழு|து அடகு சீட்|டை கண்|டிப்பாக கொண்டு வரவும்." },
                { n: "9.", t: "அடகு வைத்|த சீட்|டை தவற விட்|டால் சத்|திய கடுதா|சி கொடுத்|து தான் பொருளை பெற்|று செல்|ல முடியு|ம்." },
                { n: "10.", t: "மூன்|று மாதத்|திற்கு ஒரு முறை (அ) ஆறு மாதத்|திற்கு ஒரு முறை வட்|டி கட்|டி அடகு   சீட்|டை புதுப்|பித்|துக் கொள்|ளவும்." },
                { n: "11.", t: "ஒரு வருடகால|ம் முடிந்|து விட்|டால் லோனை புதுப்|பித்|துக் கொள்|ளவும் (அ) அசல் வட்|டி கட்|டி நகையை திருப்|பிக் கொள்|ளவும். தவறி|னால் நோட்|டீஸ் அனுப்|பி ஏல|ம் விட்|டு கணக்|கு நேர் செய்யப்ப|டும்." }
              ].map((item, index) => (
                <View key={index} style={styles.conditionRow}>
                  <Text style={styles.conditionNumber}>{item.n}</Text>
                  <Text style={styles.conditionText}>
                    {item.t.split("|").map((part, i) => (
                      <Text key={i}>{part}</Text>
                    ))}
                  </Text>
                </View>
              ))}
            </View>

            <Text style={styles.bottomText}>
              இதில் பி{""}ன்புற{""}ம் கண்{""}ட நகைகளை நா{""}ன் சரிபார்த்{""}து பெற்{""}றுக்{""}கொண்{""}டே{""}ன்.
            </Text>
            <View style={styles.signatureRow}>
              <Text style={styles.signatureText}>கையெழுத்து .........................................................</Text>
              <Text style={styles.signatureText}>தேதி .........................................................</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default JewelPawnPdf;
